import React, { useCallback } from 'react'
import styled from 'styled-components'
import { useGateValue } from '@statsig/react-bindings'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import { KC_EBIKE_SUBSIDY_FAQ_URL } from 'features/KingCounty/utils'
import { BIKE_WAITLIST_SECTION_ID } from './BikeCatalogInfoBanner'

const Helper = styled.div`
  width: 100%;
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  background-color: ${palette.secondary.purple50};
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const HelperText = styled(Text)`
  font-size: 0.875rem;
  line-height: 1.25rem;
`

const HelperLink = styled.a`
  color: ${palette.secondary.purple700};
  font-weight: 700;
  text-decoration: underline;
`

const WaitlistLink = styled.button`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: ${palette.secondary.purple700};
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
`

const KingCountyHelpers = React.memo(() => {
  const isKingCounty = useGateValue('king_county')

  const scrollToWaitlist = useCallback(() => {
    document
      .getElementById(BIKE_WAITLIST_SECTION_ID)
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [])

  if (!isKingCounty) {
    return null
  }

  return (
    <Helper>
      <HelperText variant='body2' textColor={palette.secondary.purple900}>
        Have questions about the program?{' '}
        <HelperLink
          href={KC_EBIKE_SUBSIDY_FAQ_URL}
          target='_blank'
          rel='noopener noreferrer'
        >
          Click here
        </HelperLink>
      </HelperText>
      <HelperText variant='body2' textColor={palette.secondary.purple900}>
        If you wish to wait on a waitlist instead for a chance at a prepaid
        Rybit bike, then add yourself at the{' '}
        <WaitlistLink type='button' onClick={scrollToWaitlist}>
          waitlist below
        </WaitlistLink>
        .
      </HelperText>
    </Helper>
  )
})

if (process.env.NODE_ENV !== 'production') {
  KingCountyHelpers.displayName = 'KingCountyHelpers'
}

export default KingCountyHelpers
